import axios from "axios";
import { baseURL } from "../constants/const";

const instance = axios.create({
  baseURL: baseURL,
});
const instancePrintServer = axios.create({
  baseURL: "http://localhost:8085/",
});

export const blockTicket = async (params) => {
  try {
    const response = await instance.post("/block-ticket", params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    return response;
  } catch (error) {
    console.error("Error blocking ticket:", error);
    throw error;
  }
};

export const getCountExits = async () => {
  try {
    const response = await instance.get("/count-exit");
    return response.data;
  } catch (error) {
    console.error("Error getting counting exits: ", error);
    throw error;
  }
};

export const getAntiPassbackReset = async () => {
  try {
    const response = await instance.get("/anti-passback-reset");
    return response.data;
  } catch (error) {
    console.error("Error getting anti-passback reset: ", error);
    throw error;
  }
};

export const countExit = async (value) => {
  try {
    const response = await instance.post("/count-exit", value, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    return response;
  } catch (error) {
    console.error("Error setting count exit", error);
    throw error;
  }
};

export const antiPassbackResetSet = async (value) => {
  try {
    const response = await instance.post("/anti-passback-reset", value, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    return response;
  } catch (error) {
    console.error("Error setting count exit", error);
    throw error;
  }
};

export const getActiveTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/active-tickets", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getNonActiveTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/nonactive-tickets", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching nonactive tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getMonitoring = async (startDate, endDate) => {
  try {
    const url = `/monitoring?startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}`;
    const response = await instance.get(url);
    console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching monitoring:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getPassedTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/passed", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching passed tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getSuccPassedTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/passed-succ", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching passed tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getTopSuccPassedTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/top-passed-succ", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching top passed tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getSoldTickets = async (startDate, endDate) => {
  try {
    const response = await instance.get("/sold-tickets", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sold tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getReportOptions = async (param) => {
  try {
    //console.log(param);
    const response = await instance.get("/report-options", {
      params: { param },
    });
    //console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching report options:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getCanteenReport = async (startDate, endDate) => {
  try {
    const response = await instance.get(
      `/canteen/report?startDate=${startDate}&endDate=${endDate}`
    );
    console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching canteen report: ", error);
    throw error;
  }
};

export const getCategoryTickets = async (
  startDate,
  endDate,
  selectedOption
) => {
  try {
    const response = await instance.get("/sold-category", {
      params: { startDate, endDate, selectedOption },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching cateory tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getTypeTickets = async (startDate, endDate, selectedOption) => {
  try {
    const response = await instance.get("/sold-type", {
      params: { startDate, endDate, selectedOption },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching type tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getKindTickets = async (startDate, endDate, selectedOption) => {
  try {
    const response = await instance.get("/sold-kind", {
      params: { startDate, endDate, selectedOption },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching kind tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getLogTickets = async (startDate, endDate, selectedOption) => {
  try {
    const response = await instance.get("/sold-log", {
      params: { startDate, endDate, selectedOption },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching log tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getPaymentMethodTickets = async (
  startDate,
  endDate,
  selectedOption
) => {
  try {
    const response = await instance.get("/payment-method", {
      params: { startDate, endDate, selectedOption },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payment method tickets:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getReaderIdExist = async (id) => {
  try {
    const response = await instance.get(`/reader/check-id`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching reader exists:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getReaders = async () => {
  try {
    //console.log("get readers");
    const response = await instance.get("/reader/get-readers");
    //console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching readers options:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getDaysHIK = async () => {
  try {
    const response = await instance.get("/days-hik-images");
    return response.data;
  } catch (error) {
    console.error("Error fetching days from HIK:", error);
    throw error;
  }
};

export const postDaysHIK = async (value) => {
  try {
    const response = await instance.post("/days-hik-images", value, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating days to HIK:", error);
    throw error;
  }
};

export const getWSLog = async (lines) => {
  try {
    const response = await instance.get("/get-ws-log", {
      params: { lines },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ws log: ", error);
    throw error;
  }
};

export const getFTPLog = async (lines) => {
  try {
    const response = await instance.get("/get-ftp-log", {
      params: { lines },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ftp log: ", error);
    throw error;
  }
};

export const getMailSettings = async () => {
  try {
    const response = await instance.get("/mail-configs");
    //console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching mail settings:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getReaderData = async (id) => {
  try {
    //console.log("get readers");
    const response = await instance.get("/reader/get-reader", {
      params: { id },
    });
    //console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching reader data options:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getItemData = async (id) => {
  try {
    const response = await instance.post("/get-item", id, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    console.log(response);
    return response.data[0];
  } catch (error) {
    console.error("Error fetching item data options:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getTicketIdExist = async (id) => {
  try {
    const response = await instance.get(`/ticket/check-id`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching reader exists:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getUserExist = async (username) => {
  try {
    const response = await instance.get(`/users/check`, {
      params: { username },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user exists:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getDailyReport = async (startDate, endDate) => {
  try {
    const response = await instance.get("/daily-report", {
      params: { startDate, endDate },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching daily report data:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getInfoPerTID = async (ticket_id) => {
  try {
    const response = await instance.get(`/ticket/info-id`, {
      params: { ticket_id },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching ticket info per id:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getInfoPerRegistrationPlate = async (params) => {
  try {
    const response = await instance.post("/search-plates", params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error getting ticket by registration plate:", error);
    throw error;
  }
};
export const getImages = async (reader, count, days, id = undefined) => {
  try {
    const params = {
      ...(id ? { id } : {}), // Add `id` only if it's defined and not empty
      reader,
      count,
    };
    console.log(params);
    const response = await instance.get(`/get-pass-images`, { params: params });
    console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error fetching images:", error);
    throw error;
  }
};

export const getAndroidLogById = async (id) => {
  try {
    const response = await instance.get(`/android-log?deviceId=${id}`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching android log per id:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const getAllAndroidLogs = async () => {
  try {
    const response = await instance.get("/android-log?all");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching android logs:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getImage = async (id, reader) => {
  try {
    const params = {
      id,
      reader,
    };

    const response = await instance.get(`/get-pass-image`, { params: params });
    return response.data;
  } catch (error) {
    console.error("Error fetching image per id and reader", error);
    throw error;
  }
};
export const getUsersExceptLogin = async (username) => {
  try {
    const response = await instance.get(`/perm/users`, {
      params: { username },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getPages = async () => {
  try {
    const response = await instance.get(`/perm/pages`);
    return response.data;
  } catch (error) {
    console.error("Error fetching pages:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getPermisisons = async (user_id) => {
  try {
    const response = await instance.get(`/perm/permissions`, {
      params: { user_id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getTicket = async (id) => {
  try {
    const response = await instance.get(`/get/ticket`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ticket:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};
export const getPriceList = async () => {
  try {
    const response = await instance.get("/price-list");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching price list:", error);
    throw error; // Propagirajte grešku kako bi je mogli obraditi u komponenti koja poziva ovu funkciju
  }
};

export const postRequest = async (endpoint, formData) => {
  let ret = { success: false, message: "", other: "" };
  try {
    const response = await instance.post(endpoint, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    console.log(response.data);
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    ret.other = response.data.other;
    return ret;
  } catch (error) {
    console.error("Error posting data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    } else if (error.response.status === 400) {
      console.log("Bad Request");
      ret.message = "Bad Request";
    } else if (error.response.status === 401) {
      console.log("Unauthorized");
      ret.message = "Unauthorized";
    } else {
      console.log("Post request failed");
      ret.message = "Post request failed";
    }
    return ret;
  }
};
export const editReader = async (reader) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/reader`, reader, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};
export const editTicket = async (ticket) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/ticket`, ticket, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};
export const editTicketUser = async (user) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/ticket-user`, user, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};

export const getTypes = async () => {
  try {
    const response = await instance.get("/get-types");
    return response.data;
  } catch (error) {
    console.error("Error fetching types:", error);
    throw error;
  }
};

export const getUpdateFiles = async () => {
  try {
    const response = await instance.get("/get-versions");
    return response.data;
  } catch (error) {
    console.error("Error fetching update files:", error);
    throw error;
  }
};

export const getKinds = async () => {
  try {
    const response = await instance.get("/get-kinds");
    return response.data;
  } catch (error) {
    console.error("Error fetching kinds:", error);
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const response = await instance.get("/get-categories");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getOrganizationUnitById = async (id) => {
  try {
    const response = await instance.get(`/canteen/organization-unit?${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching organizational units:", error);
    throw error;
  }
};

export const getOrgranizationalUnits = async () => {
  try {
    const response = await instance.get("/canteen/organization-unit?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching organizational units:", error);
    throw error;
  }
};

export const addArticle = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/article",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding article:", error);
    throw error;
  }
};

export const addIngredient = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/ingredient",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding ingredient:", error);
    throw error;
  }
};

export const addEmployee = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/employee",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding employee:", error);
    throw error;
  }
};
export const addRecipe = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/recipe",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding recipe:", error);
    throw error;
  }
};

export const addUnitOfMeasure = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/unit-of-measure-unit",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding organization unit:", error);
    throw error;
  }
};

export const addOrganizationUnit = async (params) => {
  try {
    const response = await instance.post(
      "/canteen/organization-unit",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding organization unit:", error);
    throw error;
  }
};

export const editArticle = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/article",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing article:", error);
    throw error;
  }
};

export const editIngredient = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/ingredient",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing ingredient:", error);
    throw error;
  }
};

export const editRecipe = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/recipe",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing recipes:", error);
    throw error;
  }
};

export const editEmployee = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/employee",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing employee:", error);
    throw error;
  }
};

export const editUnitOfMeasure = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/unit-of-measure-unit",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing unit of measure:", error);
    throw error;
  }
};

export const editOrganizationUnit = async (params) => {
  try {
    const response = await instance.put(
      "/canteen/organization-unit",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error editing employee:", error);
    throw error;
  }
};

export const getArticles = async () => {
  try {
    const response = await instance.get("/canteen/article?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching articles:", error);
    throw error;
  }
};
export const getRecipes = async () => {
  try {
    const response = await instance.get("/canteen/recipe?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching recipes:", error);
    throw error;
  }
};
export const getIngredients = async () => {
  try {
    const response = await instance.get("/canteen/ingredient?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching ingredients:", error);
    throw error;
  }
};

export const getEmployees = async () => {
  try {
    const response = await instance.get("/canteen/employee?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const getUnitsOfMeasure = async () => {
  try {
    const response = await instance.get("/canteen/unit-of-measure-unit?all");
    return response.data;
  } catch (error) {
    console.error("Error fetching units of measure: ", error);
    throw error;
  }
};

export const addItem = async (params) => {
  try {
    const response = await instance.post("/add-item", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response;
  } catch (error) {
    console.error("Error adding item:", error);
    throw error;
  }
};

export const ticketSendEmail = async (formData) => {
  try {
    const response = await instance.post("/send-mail", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error in ticketSendEmail:", error);
    throw error;
  }
};

export const changeUserPassword = async (params) => {
  try {
    const response = await instance.post("/change-password", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const addKind = async (params) => {
  try {
    const response = await instance.post("/add-kind", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding kind:", error);
    throw error;
  }
};

export const addCategory = async (params) => {
  try {
    const response = await instance.post("/add-category", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};

export const searchUsersWithTickets = async (params) => {
  try {
    const response = await instance.post("/search-users", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error searching users:", error);
    throw error;
  }
};

export const deleteEmployee = async (id) => {
  try {
    const response = await instance.delete(`/canteen/employee?id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting employee: ", error);
    throw error;
  }
};

export const deleteOrganizationUnit = async (id) => {
  try {
    const response = await instance.delete(
      `/canteen/organization-unit?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting organization unit: ", error);
    throw error;
  }
};

export const deleteUnitOfMeasure = async (id) => {
  try {
    const response = await instance.delete(
      `/canteen/unit-of-measure-unit?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting unit of measure: ", error);
    throw error;
  }
};

export const deleteArticle = async (id) => {
  try {
    const response = await instance.delete(`/canteen/article?id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting article: ", error);
    throw error;
  }
};

export const deleteIngredient = async (id) => {
  try {
    const response = await instance.delete(`/canteen/ingredient?id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting ingredient: ", error);
    throw error;
  }
};

export const deleteItem = async (params) => {
  try {
    const response = await instance.post("/delete-item", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting item:", error);
    throw error;
  }
};

export const deleteKind = async (params) => {
  try {
    const response = await instance.post("/delete-kind", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting kind:", error);
    throw error;
  }
};

export const deleteCategory = async (params) => {
  try {
    const response = await instance.post("/delete-category", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting category:", error);
    throw error;
  }
};

export const deleteReader = async (params) => {
  try {
    const response = await instance.post("/delete-reader", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting reader:", error);
    throw error;
  }
};

export const updateDatabase = async () => {
  try {
    const response = await instance.post("/update-database", null, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating database: ", error);
    throw error;
  }
};

// PRINT SERVER - PORT 8085

export const openPrinterSession = async () => {
  try {
    const response = await instance.post(
      "/printer/open",
      {},
      {
        baseURL: "http://localhost:8085/",
        headers: {
          "X-API-KEY": "123456",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error opening printer session:", error);
    throw error;
  }
};

export const sendTicketData = async (ticketData, paymentType, mode) => {
  try {
    const payload = { ...ticketData, paymentType, mode };

    const response = await instancePrintServer.post("/printer/data", payload, {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending ticket data:", error);
    throw error;
  }
};

export const closePrinterSession = async () => {
  try {
    const response = await instance.post(
      "/printer/close",
      {},
      {
        baseURL: "http://localhost:8085/",
        headers: { "X-API-KEY": "123456" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error closing printer session:", error);
    throw error;
  }
};
// dizajn karte

export const getDesigns = async () => {
  try {
    const response = await instance.get("/ticket-design");
    return response.data;
  } catch (error) {
    console.error("Error fetching types:", error);
    throw error;
  }
};
export const deleteDesign = async (id) => {
  try {
    const response = await instance.delete("/ticket-design", {
      params: { id },
    });
    return response;
  } catch (error) {
    console.error("Error deleting ticket design:", error);
    throw error;
  }
};
export const saveTicketDesign = async (designData) => {
  try {
    const response = await instance.post("/ticket-design", designData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending ticket design:", error);
    throw error;
  }
};

export const sendTicketConfig = async (designData) => {
  try {
    const response = await instance.post("printer/receive-design", designData, {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending ticket design:", error);
    throw error;
  }
};

export const getTicketConfig = async () => {
  try {
    const response = await instance.get("printer/get-design", {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Greška pri preuzimanju konfiguracije karte:", error);
    return null; // Ako dođe do greške, vrati null umesto undefined
  }
};
// fiskalizacija
export const fiskalizacija = async (
  ticketData,
  paymentType,
  mode,
  isAdvance
) => {
  try {
    const payload = { ticketData, paymentType, mode, isAdvance };

    const response = await instance.post(
      "http://localhost:8085/printer/fiskalizuj",
      payload,
      {
        baseURL: "http://localhost:8085/",
        headers: {
          "X-API-KEY": "123456",
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      await closePrinterSession(); // Zatvori sesiju za štampanje
    } else {
      console.error("Fiskalizacija nije uspela sa statusom:", response.status);
    }
    return response.data;
  } catch (error) {
    console.error("Error fiskalizacija:", error);
    return null;
  }
};

// reports
export const sendReportsData = async (reportsData) => {
  try {
    const response = await axios.post(
      "http://localhost:8085/printer/reports",
      reportsData,
      {
        headers: {
          "X-API-KEY": "123456",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error sending reports data:", error);
    throw error;
  }
};

export const getInvoices = async () => {
  try {
    const response = await instance.get("printer/get-refund", {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });

    const lines = response.data.trim().split("\n");
    const invoiceNumbers = lines.map((line) => line.split(",")[0]); // uzimamo samo broj računa

    return invoiceNumbers;
  } catch (error) {
    console.error("Greška pri preuzimanju racuna:", error);
    return []; // Ako dođe do greške, vrati null umesto undefined
  }
};
// END (PRINT SERVER)

export const openBarrier = async (params) => {
  try {
    const response = await instance.post("/open-barrier", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error openning barrier:", error);
    throw error;
  }
};

export const soundSupport = async ({
  command,
  serial_number,
  target_device_id,
  payload,
}) => {
  try {
    const formData = new URLSearchParams();
    formData.append("command", command);
    formData.append("serial_number", serial_number);
    if (target_device_id) formData.append("target_device_id", target_device_id);
    if (payload) formData.append("payload", JSON.stringify(payload));

    const response = await instance.post("/sound-support", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error with sound support:", error);
    throw error;
  }
};

export const getTemplateGroups = async () => {
  try {
    const response = await instance.get("/get-groups", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching groups:", error);
    throw error;
  }
};

export const addTemplateGroup = async (params) => {
  try {
    const response = await instance.post("/add-group", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding group:", error);
    throw error;
  }
};

export const getTemplateGroupEvents = async () => {
  try {
    const response = await instance.get("/get-group-events", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching group events:", error);
    throw error;
  }
};

export const addTemplateGroupEvent = async (params) => {
  try {
    const response = await instance.post("/add-group-event", params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding group event:", error);
    throw error;
  }
};

export const getGroupById = async (id) => {
  try {
    const response = await instance.get(`/get-group-by-id?id=${id}`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting group:", error);
    throw error;
  }
};

export const getMode = async () => {
  try {
    const response = await instance.get(`/get-mode`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting mode:", error);
    throw error;
  }
};

export const getFiscalizationMode = async () => {
  try {
    const response = await instance.get(`/fiscalization-mode`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting fiscalization mode:", error);
    throw error;
  }
};

export const getFiscalizationStatus = async () => {
  try {
    const response = await instance.get(`/fiscalization-mode`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting fiscalization status:", error);
    throw error;
  }
};

export const getLockers = async () => {
  try {
    const response = await instance.get(`/lockers/locker?all`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting lockers:", error);
    throw error;
  }
};

export const addLockerGroup = async (params) => {
  try {
    const response = await instance.post(
      "/lockers/locker",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding locker group:", error);
    throw error;
  }
};

export const updateLocker = async (params) => {
  try {
    const response = await instance.put(
      "/lockers/locker",
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding locker group:", error);
    throw error;
  }
};

export const deleteLocker = async (id) => {
  try {
    const response = await instance.delete(`/lockers/locker?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error adding locker group:", error);
    throw error;
  }
};

export const listBackups = async () => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'list-backups');
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error listing backups:", error);
    throw error;
  }
};

export const createBackup = async () => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'create-backup');
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating backup:", error);
    throw error;
  }
};
export const runBackup = async (filename) => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'run-backup');
    params.append('filename', filename);
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error running backup:", error);
    throw error;
  }
};
export const latestBackup = async () => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'get-latest-backup');
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching latest backup time:", error);
    throw error;
  }
};
export const getCameraMode = async () => {
  try {
    const response = await instance.get(`/get-camera-mode`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting mode:", error);
    throw error;
  }
};

export const runUpdate = async (filename) => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'run-update');
    params.append('filename', filename);
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error running update:", error);
    throw error;
  }
};
export const getUpdate = async (filename) => {
  try {
    const params = new URLSearchParams();
    params.append('action', 'get-update');
    params.append('filename', filename);
    
    const response = await instance.post(`/database-backup`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error running update:", error);
    throw error;
  }
};
export default instance;
